// Module
var code = "<iframe width=\"100%\" height=\"100%\" id=\"sisense-iframe\"> </iframe> ";
// Exports
module.exports = code;